import { THttpMethod } from '@/types/FetchService.types';
export interface IEndpoint {
  method: THttpMethod;
  url: string;
}
export const featuresSlugs = {
  ALL_APP: 'ALL_APP',
  AUTH: 'AUTH',
  KEYS: 'KEYS',
  CONFIG: 'CONFIG',
  AUTH_2FA: 'AUTH_2FA',
  SEARCH_USERS: 'SEARCH_USERS',
  PROFILES_BOARD: 'PROFILES_BOARD',
  ALL_USERS: 'ALL_USERS',
  CREATE_USER: 'CREATE_USER',
  ALL_CARD_TRANSACTIONS: 'ALL_CARD_TRANSACTIONS',
  ALL_CARDS: 'ALL_CARDS',
  ALL_WALLETS: 'ALL_WALLETS',
  ALL_BENEFICIARIES: 'ALL_BENEFICIARIES',
  USERS_PREVALIDATION_NEEDED: 'USERS_PREVALIDATION_NEEDED',
  BULK_CARDS: 'BULK_CARDS',
  USERS_ONBOARDING: 'USERS_ONBOARDING',
  DASHBOARD_USERS: 'DASHBOARD_USERS',
  ACCOUNT_OVERVIEW: 'ACCOUNT_OVERVIEW',
  PREDEF_RESTRICTIONS_GROUPS: 'PREDEF_RESTRICTIONS_GROUPS',
  TEMPLATES: 'TEMPLATES',
  SYSTEM_CONFIGURATION: 'SYSTEM_CONFIGURATION',
  WEBHOOKS: 'WEBHOOKS',
  CRYPTOGRAPHY: 'CRYPTOGRAPHY',
  EDIT_TAX_RESIDENCES: 'EDIT_TAX_RESIDENCES',
  DESACTIVATE_USER: 'DESACTIVATE_USER',
  SEND_FORGOT_PASSWORD: 'SEND_FORGOT_PASSWORD',
  EDIT_INFORMATIONS: 'EDIT_INFORMATIONS',
  ORGANIZE_ELEMENTS: 'ORGANIZE_ELEMENTS',
  SCA_ON_WALLET: 'SCA_ON_WALLET',
  ADD_KYC_DOCUMENT: 'ADD_KYC_DOCUMENT',
  SUBMIT_KYC: 'SUBMIT_KYC',
  REVIEW_DOCUMENT: 'REVIEW_DOCUMENT',
  DOWNLOAD_DOCUMENT: 'DOWNLOAD_DOCUMENT',
  DELETE_DOCUMENT: 'DELETE_DOCUMENT',
  DELETE_KYC_DOC_PROCESSED: 'DELETE_KYC_DOC_PROCESSED',
  ADD_WALLET: 'ADD_WALLET',
  PAYOUT: 'PAYOUT',
  WALLET_TO_WALLET_TRANSFER: 'WALLET_TO_WALLET_TRANSFER',
  DOWNLOAD_OPERATIONS: 'DOWNLOAD_OPERATIONS',
  WALLET_DETAILS: 'WALLET_DETAILS',
  ACCOUNT_DETAIL: 'ACCOUNT_DETAIL',
  EDIT_WALLET: 'EDIT_WALLET',
  STATEMENT: 'STATEMENT',
  DEACTIVATE_WALLET: 'DEACTIVATE_WALLET',
  SIMULATION: 'SIMULATION',
  EDIT_CARDS: 'EDIT_CARDS',
  SET_PIN: 'SET_PIN',
  CREATE_BENEFICIARY: 'CREATE_BENEFICIARY',
  EDIT_BENEFICIARY: 'EDIT_BENEFICIARY',
  ADD_CHILD: 'ADD_CHILD',
  CREATE_CARDS: 'CREATE_CARDS',
  BALANCE_CERTIFICATE: 'BALANCE_CERTIFICATE',
  CLOSURE_CERTIFICATE: 'CLOSURE_CERTIFICATE',
  DOMICILIATION_CERTIFICATE: 'DOMICILIATION_CERTIFICATE',
} as const;
export const featuresNames = {
  ALL_APP: 'All App',
  AUTH: 'Auth',
  KEYS: 'Keys',
  CONFIG: 'Config',
  AUTH_2FA: 'Auth 2FA',
  SEARCH_USERS: 'Search Users',
  PROFILES_BOARD: 'Profiles board',
  ALL_USERS: 'All Users',
  CREATE_USER: 'Create User',
  ALL_CARD_TRANSACTIONS: 'All Card Transactions',
  ALL_CARDS: 'All Cards',
  ALL_WALLETS: 'All Wallets',
  ALL_BENEFICIARIES: 'All Beneficiaries',
  USERS_PREVALIDATION_NEEDED: 'Users Pre+validation needed',
  BULK_CARDS: 'Bulk Cards',
  USERS_ONBOARDING: 'Users Onboarding',
  DASHBOARD_USERS: 'Dashboard Users',
  PREDEF_RESTRICTIONS_GROUPS: 'Predef Restrictions Groups',
  TEMPLATES: 'Templates',
  SYSTEM_CONFIGURATION: 'System Configuration',
  WEBHOOKS: 'Webhooks',
  CRYPTOGRAPHY: 'Cryptography',
  EDIT_TAX_RESIDENCES: 'Edit tax residences',
  DESACTIVATE_USER: 'Deactivate User',
  SEND_FORGOT_PASSWORD: 'Send forgot password',
  EDIT_INFORMATIONS: 'Edit informations',
  ORGANIZE_ELEMENTS: 'Organize elements',
  SCA_ON_WALLET: 'SCA on wallet',
  ADD_KYC_DOCUMENT: 'Add KYC document',
  SUBMIT_KYC: 'Submit KYC to Treezor',
  REVIEW_DOCUMENT: 'Review document',
  DOWNLOAD_DOCUMENT: 'Download document',
  DELETE_DOCUMENT: 'Delete document',
  DELETE_KYC_DOC_PROCESSED: 'Delete KYC doc processed',
  ADD_WALLET: 'Add Wallet',
  PAYOUT: 'Payout',
  WALLET_TO_WALLET_TRANSFER: 'Wallet to Wallet Transfer',
  DOWNLOAD_OPERATIONS: 'Download Operations',
  WALLET_DETAILS: 'Wallet Details',
  ACCOUNT_DETAIL: 'Account detail',
  EDIT_WALLET: 'Edit Wallet',
  STATEMENT: 'Statement',
  DEACTIVATE_WALLET: 'Deactivate Wallet',
  SIMULATION: 'Simulation',
  EDIT_CARDS: 'Edit cards',
  SET_PIN: 'Set pin',
  CREATE_BENEFICIARY: 'Create beneficiary',
  EDIT_BENEFICIARY: 'Edit beneficiary',
  ADD_CHILD: 'Add Child',
  CREATE_CARDS: 'Create cards',
  BALANCE_CERTIFICATE: 'Balance certificate',
  CLOSURE_CERTIFICATE: 'Closure certificate',
  DOMICILIATION_CERTIFICATE: 'Domiciliation certificate',
} as const;
export type TFeatureNames = (typeof featuresNames)[keyof typeof featuresNames];
export type TFeatureSlugs = (typeof featuresSlugs)[keyof typeof featuresSlugs];
export interface IFeature {
  name?: TFeatureNames;
  slug: TFeatureSlugs;
  endpoints?: IEndpoint[];
  routes?: string[];
}
